module.exports = __webpack_public_path__ + "assets/img/88.png?ee09f2aa347f1418b37c4fc10737c70c";